// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content {
  padding: 20px;
  margin: 20px 5px;
}

.label {
  margin-bottom: 15px;
  font-size: 1.2rem;
}

.mat-step-icon::ng-deep {
  margin-right: 0px;
  flex: none;
}

.bloc-lock {
  margin-bottom: 10px;
}
.bloc-lock .icon-lock {
  font-size: 2rem;
  margin-right: 20px;
  width: 33px;
  height: 33px;
}

.bloc-phone {
  margin-top: 20px;
}
.bloc-phone ::ng-deep ngx-intl-tel-input input {
  border-radius: 10px;
  border-style: dotted;
  padding: 10px 1px 10px 50px;
  font-size: 1rem;
  outline: 0;
  border-width: 1px;
}

.bloc-codes .input-digit {
  width: 60px;
  font-size: 2.8rem;
  text-align: center;
  border-radius: 15px;
  border-width: 1px;
  outline: 0;
}

.bloc-error {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  margin-top: 15px;
}
.bloc-error p {
  margin: 15px;
}

.bloc-signature {
  background-color: transparent;
}

.section-position {
  margin-bottom: 20px;
}
.section-position label {
  margin-right: 10px;
}
.section-position .example-margin {
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/+sites/document-library/shared/dialog-sign-document/dialog-sign-document.component.scss"],"names":[],"mappings":"AAEA;EACI,aAAA;EACA,gBAAA;AADJ;;AAIA;EACI,mBAAA;EACA,iBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,UAAA;AADJ;;AAOA;EACI,mBAAA;AAJJ;AAMI;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAJR;;AAQA;EACI,gBAAA;AALJ;AAQQ;EACI,mBAAA;EACA,oBAAA;EACA,2BAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;AANZ;;AAYI;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AATR;;AAaA;EACI,cAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAVJ;AAYI;EACI,YAAA;AAVR;;AAoBA;EACI,6BAAA;AAjBJ;;AAoBA;EACI,mBAAA;AAjBJ;AAmBI;EACI,kBAAA;AAjBR;AAoBI;EACI,kBAAA;AAlBR","sourcesContent":["\r\n@import \"/src/styles/_variables.scss\";\r\n.modal-content {\r\n    padding: 20px;\r\n    margin: 20px 5px;\r\n}\r\n\r\n.label {\r\n    margin-bottom: 15px;\r\n    font-size: 1.2rem;\r\n}\r\n\r\n.mat-step-icon::ng-deep {\r\n    margin-right: 0px; \r\n    flex: none;  \r\n}\r\n\r\n\r\n\r\n \r\n.bloc-lock {\r\n    margin-bottom: 10px;\r\n\r\n    .icon-lock {\r\n        font-size: 2rem;\r\n        margin-right: 20px;\r\n        width:33px;\r\n        height:33px;\r\n    }\r\n}\r\n\r\n.bloc-phone {\r\n    margin-top: 20px;\r\n\r\n    ::ng-deep ngx-intl-tel-input {\r\n        input {\r\n            border-radius: 10px;\r\n            border-style: dotted;\r\n            padding: 10px 1px 10px 50px;\r\n            font-size: 1rem;\r\n            outline: 0;\r\n            border-width: 1px;\r\n        }\r\n    }\r\n}\r\n\r\n.bloc-codes {\r\n    .input-digit {\r\n        width: 60px;\r\n        font-size: 2.8rem;\r\n        text-align: center;\r\n        border-radius: 15px;\r\n        border-width: 1px;\r\n        outline: 0;\r\n    }\r\n}\r\n\r\n.bloc-error {\r\n    color: #721c24;\r\n    background-color: #f8d7da;\r\n    border-color: #f5c6cb;\r\n    margin-top: 15px;\r\n\r\n    p {\r\n        margin: 15px;\r\n    }\r\n}\r\n\r\n// .text-ellipsis{\r\n//     width: 100px; /* à modifier selon vos besoins */\r\n//     overflow: hidden;\r\n//     text-overflow: ellipsis;          \r\n// }\r\n\r\n.bloc-signature {\r\n    background-color: transparent;\r\n}\r\n\r\n.section-position {\r\n    margin-bottom: 20px;\r\n\r\n    label {\r\n        margin-right: 10px;\r\n    }\r\n\r\n    .example-margin {\r\n        margin-right: 10px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
